import { useSelector } from "hooks";
import { useMemo } from "react";

const useZendeskDomain = (): string | null => {
  const zendeskDomain = useSelector(
    (state) =>
      state.auth?.attributes?.zendeskDomainTemp ||
      state.auth?.attributes?.zendeskDomain,
  );
  // fall back to the env file for now
  if (zendeskDomain === "" || typeof zendeskDomain === "undefined") {
    return process.env.GATSBY_ZENDESK || null;
  }
  return zendeskDomain;
};

const useZendeskKey = (): string | null => {
  const zendeskKey = useSelector(
    (state) =>
      state.auth?.attributes?.zendeskKeyTemp ||
      state.auth?.attributes?.zendeskKey,
  );
  // fall back to the env file for now
  if (zendeskKey === "" || typeof zendeskKey === "undefined") {
    return process.env.GATSBY_ZENDESK_KEY || null;
  }
  return zendeskKey;
};

const useZendeskMessengerToken = (): string | null => {
  return useSelector((state) => state.auth?.attributes?.zendeskMessengerToken);
};

/**
 * Handles clicks on banners and promotions. Extended to detect `data-helpcenter`
 * attributes since banners/promotions do not pass href which can be handled
 * for Zendesk domains in HelpCenter
 */
const useHelpcenterAttributes = () => {
  const zendeskDomain = useZendeskDomain();

  const zendeskDomains = useMemo(() => {
    return [
      "picklebettest.zendesk.com",
      "help.picklebet.com",
      zendeskDomain,
    ].filter((domain) => typeof domain === "string");
  }, [zendeskDomain]);

  const isZendeskUrl = (url: string | undefined): boolean => {
    if (!url) return false;
    return zendeskDomains.some((domain) => url.includes(domain));
  };

  const getHelpcenterAttributes = (url: string | undefined) => {
    return isZendeskUrl(url) ? { "data-helpcenter": url } : {};
  };

  return {
    zendeskDomains,
    isZendeskUrl,
    getHelpcenterAttributes,
  };
};

export {
  useZendeskDomain,
  useZendeskKey,
  useZendeskMessengerToken,
  useHelpcenterAttributes,
};
